import api from './AxiosInstance';
import printJS from "print-js";
import { api_URL } from "./Constantes";

export class RembousementsService {
  //
  getParam3 = async () => {
    try {
      const response = await api.get(`/InfosGen/DateCompta/param3`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getRembFraisMdcx = async (payload) => {
    try {
      const response = await api.post(`/Compta/RembFraisMdcx`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  PreviewCompta = async (payload) => {
    try {
      const response = await api.post(`Compta/PreviewRembFraisMdcx`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  validComptaReg = async (payload) => {
    try {
      const response = await api.post(`Compta/ValidPreviewRembFraisMdcx`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getType = async (type) => {
    try {
      const response = await api.get(`/SaisieJournal/list/ByType?type=${type}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getRemboursements = async (selectedYear, selectedMonth) => {
    try {
      const response = await api.get(`/Compta/Remb/list?annee=${selectedYear}&mois=${selectedMonth}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  printRemboursementService = (codej, codeadht, docName) => {
    const userId = localStorage.getItem('login');
    const username = localStorage.getItem('username');
    const url = `${api_URL}/Print/Reglement/RembFM/${codej}/${codeadht}?docName=${docName}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'user_id': userId,
        'username': username,
      },
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printLettreChequeService = (docName, codeadht, dest = null) => {
    const userId = localStorage.getItem('login');
    const username = localStorage.getItem('username');
    let url = `${api_URL}/Print/Reglement/RembFM/LettreCheque/${codeadht}?docName=${docName}`;
    if (docName === "Lettre_Cheque_RIB_GLB" && dest) {
      url += `&dest=${dest}`;
    }

    fetch(url, {
      method: 'GET',
      headers: {
        'user_id': userId,
        'username': username,
      },
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printCompta = async (docData) => {
    try {
      const response = await api.put(`/Compta/updatedPrintedCompta`, docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  cancelRemboursement = async (payload) => {
    try {
      const response = await api.post(`/Compta/cancelRemboursement`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

}


